import { GameMap } from "../games";

export default [
  {
    name: 'start',
    title: 'Command HQ',
    collection: ''
  },
  {
    name: 'hip1m1',
    title: 'The Pumping Station',
    collection: 'Episode 1'
  },
  {
    name: 'hip1m2',
    title: 'Storage Facility',
    collection: 'Episode 1'
  },
  {
    name: 'hip1m3',
    title: 'The Lost Mine',
    collection: 'Episode 1'
  },
  {
    name: 'hip1m4',
    title: 'Research Facility',
    collection: 'Episode 1'
  },
  {
    name: 'hip1m5',
    title: 'Military Complex',
    collection: 'Episode 1'
  },
  {
    name: 'hip2m1',
    title: 'Ancient Realms',
    collection: 'Episode 2'
  },
  {
    name: 'hip2m2',
    title: 'The Black Cathedral',
    collection: 'Episode 2'
  },
  {
    name: 'hip2m3',
    title: 'The Catacombs',
    collection: 'Episode 2'
  },
  {
    name: 'hip2m4',
    title: 'The Crypt',
    collection: 'Episode 2'
  },
  {
    name: 'hip2m5',
    title: 'Mortum\'s Keep',
    collection: 'Episode 2'
  },
  {
    name: 'hip2m6',
    title: 'The Gremlin\'s Domain',
    collection: 'Episode 2'
  },
  {
    name: 'hip3m1',
    title: 'Tur Torment',
    collection: 'Episode 3'
  },
  {
    name: 'hip3m2',
    title: 'Pandemonium',
    collection: 'Episode 3'
  },
  {
    name: 'hip3m3',
    title: 'Limbo',
    collection: 'Episode 3'
  },
  {
    name: 'hip3m4',
    title: 'The Gauntlet',
    collection: 'Episode 3'
  },
  {
    name: 'hipend',
    title: 'Armagon\'s Lair',
    collection: 'Episode 3'
  },
  {
    name: 'hipdm1',
    title: 'The Edge of Oblivion',
    collection: 'Episode 3'
  },
] as GameMap[]
